// src/features/projects/components/StarBorder.tsx

import React, { ElementType, useRef } from 'react';
import styles from './StarBorder.module.scss';

interface StarBorderProps {
  as?: ElementType;
  className?: string;
  color?: string;
  speed?: string;
  children: React.ReactNode;
}

/**
 * Renders a "starry border" effect around the contained children.
 * Adapts to your theme if you pass a suitable "color" or rely on SCSS variables.
 */
const StarBorder: React.FC<StarBorderProps> = ({
  as: Component = 'div',
  className = '',
  color = '',
  speed = '6s',
  children,
  ...rest
}) => {
  const divRef = useRef<HTMLDivElement>(null);

  return (
    <Component ref={divRef} className={`${styles.starBorderContainer} ${className}`} {...rest}>
      <div
        className={styles.borderGradientBottom}
        style={{
          background: `radial-gradient(circle, ${color}, transparent 10%)`,
          animationDuration: speed,
        }}
      />
      <div
        className={styles.borderGradientTop}
        style={{
          background: `radial-gradient(circle, ${color}, transparent 10%)`,
          animationDuration: speed,
        }}
      />
      <div className={styles.innerContent}>{children}</div>
    </Component>
  );
};

export default StarBorder;